<template>
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Alignment-Navi" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="D_05.1_EG-Grundriss"
        transform="translate(-476.000000, -1007.000000)"
        fill="currentColor"
      >
        <g id="Process" transform="translate(381.000000, 984.000000)">
          <g
            id="Organization-/-Status-/-checkmark--outline-/-24"
            transform="translate(94.000000, 22.000000)"
          >
            <path
              d="M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,6.14348457 14.2625021,4.36300718 12.9497475,3.05025253 C11.6369928,1.73749788 9.85651543,1 8,1 Z M8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 L8,14 Z M7,10.75 L4.5,8.27 L5.295,7.485 L7,9.175 L10.705,5.5 L11.5,6.29 L7,10.75 Z"
              id="Fill"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CheckCircle'
};
</script>
